































import { Component, Vue,Prop, Model, Watch  } from "vue-property-decorator";
import draggable from 'vuedraggable'
import setForm from './setForm.vue'
@Component({
  components: {
    draggable,
    'set-form':setForm,
  },
})
export default class componentForm extends Vue {
  @Prop(Array)
  formList!:any;

  @Prop(Boolean)
  compontentFormIsShow!:boolean;

  @Prop(Object)
  formType!:Object;

  @Prop(Boolean)
  deleteIfShow!:boolean;

  @Prop(Boolean)
  draggableDisabled!:boolean;


  // SKA2792: 固定模板禁用编辑图标
  @Prop(Boolean)
  editDisabled!:boolean;

  @Prop({ type: Boolean, default: false })
  necessaryLocked!: boolean;
  
  @Prop(Array)
  countryList!:any

  @Prop(Number)
  triggerEventType!: number

  @Prop([Number, String])
  templateId!: number | string

  @Prop({ type: Object, default: () => ({}) })
  optimizerFirstStepContext!: Record<string, any>

  @Prop({ type: Boolean, default: false })
  optimizerReadOnly!: boolean

  setformType = {}
  myArray = this.formList

  Edit = -1

  del(element:any,index:number){
    this.myArray.splice(index,1)
    this.$emit('changeFormList',this.myArray)
  }

  setFormItem(element:any,index:number){
    // email 增加默认值
    if (element.type === 'Email' && element.enablePrivacyShow === undefined) {
      element.enablePrivacyShow = false;
      element.text = 'Subscribe to marketing emails and our ';
      element.linkText = 'Privacy Policy';
    }

    this.setformType = element
    this.Edit = index
    this.$emit('changcompontentFormIsShow', true)
  }

  closeSetForm(e:boolean){
    // 关闭弹窗时重置编辑状态
    if (!e) {
      this.Edit = -1;
      this.setformType = JSON.parse(JSON.stringify(this.formType));
    }
    this.$emit('changcompontentFormIsShow', e)
  }

  changFormItem(e:any){
    if(this.Edit >= 0){
      let arr =  JSON.parse(JSON.stringify(this.myArray))
      arr[this.Edit] = e
      this.myArray = arr
    }else{
      if (e.type === '自定义') {
        this.myArray.push(e)
      }else{
        let index
        this.formList.filter((item:any,num:number)=>{
          if (item.type === e.type) {
            index = num
          }
        })
        if (typeof(index) ==='number' ) {
          let arr =  JSON.parse(JSON.stringify(this.myArray))
          arr[index] = e
          this.myArray = arr
        }else{
          this.myArray.push(e)
        }
      }
    }
    this.Edit = -1
    this.setformType = JSON.parse(JSON.stringify(this.formType))
    this.$emit('changeFormList', this.myArray)
    this.$emit('changcompontentFormIsShow', false)
  }

  @Watch('formType')
  wacthFormType(val:any){
    if(this.Edit >= 0){

    }else{
      this.setformType = JSON.parse(JSON.stringify(this.formType))
    }
  }

  @Watch('myArray')
  wacthMyArray(val:any){
    this.$emit('changeFormList',this.myArray)
  }

  @Watch('formList')
  wacthFormList(val:any){
    this.myArray = val
  }

}
